import React from 'react';
import { CancelIcon, colors, useComponentTheme } from '@chegg-ui/theme';
import { Error, ErrorText, FormGroup, getThemeConfig, HelperText, Label, LeadingIconPositioner, TrailingIconPositioner } from '../styles';

/**
 * InputWrapper takes care of:
 * - Label and Label Placement
 * - Error state
 * - Helper text
 * - Trailing Icons within the input
 * */
export var InputWrapper = function InputWrapper(props) {
  var dataTest = props['data-test'],
      adjustToBackgroundColor = props.adjustToBackgroundColor,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      errorCta = props.errorCta,
      errorText = props.errorText,
      helperText = props.helperText,
      inputId = props.inputId,
      leadingIcon = props.leadingIcon,
      leadingIconClickable = props.leadingIconClickable,
      labelText = props.labelText,
      onLabelMouseEnter = props.onLabelMouseEnter,
      onLabelMouseLeave = props.onLabelMouseLeave,
      theme = props.theme,
      trailingIcon = props.trailingIcon,
      trailingIconClickable = props.trailingIconClickable,
      visuallyHideLabel = props.visuallyHideLabel,
      width = props.width;
  var componentTheme = useComponentTheme({
    name: 'InputWrapper',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(FormGroup, {
    width: width,
    errorText: errorText,
    helperText: helperText,
    className: className,
    "data-test": "".concat(dataTest || inputId, "_group")
  }, /*#__PURE__*/React.createElement(Label, {
    id: "".concat(inputId, "_label"),
    htmlFor: inputId,
    visuallyHidden: visuallyHideLabel,
    onMouseEnter: onLabelMouseEnter,
    onMouseLeave: onLabelMouseLeave,
    "data-test": "".concat(dataTest || inputId, "_label"),
    adjustToBackgroundColor: adjustToBackgroundColor,
    customTheme: componentTheme,
    disabled: disabled
  }, labelText), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.cloneElement(children, {
    'aria-describedby': helperText ? "".concat(inputId, "_helptext") : errorText ? "".concat(inputId, "_error") : undefined,
    'aria-invalid': errorText ? true : false,
    errorText: errorText // TODO: should further evaluate this errorText cloning, not sure this is the right approach

  }), leadingIcon && /*#__PURE__*/React.createElement(LeadingIconPositioner, {
    customTheme: componentTheme,
    "data-test": "".concat(dataTest || inputId, "_leading_icon_positioner"),
    disabled: disabled,
    leadingIconClickable: leadingIconClickable
  }, /*#__PURE__*/React.cloneElement(leadingIcon, {
    size: 'xsmall'
  })), trailingIcon && /*#__PURE__*/React.createElement(TrailingIconPositioner, {
    customTheme: componentTheme,
    "data-test": "".concat(dataTest || inputId, "_icon_positioner"),
    disabled: disabled,
    trailingIconClickable: trailingIconClickable
  }, /*#__PURE__*/React.cloneElement(trailingIcon, {
    size: 'xsmall'
  }))), errorText && /*#__PURE__*/React.createElement(Error, {
    role: 'alert',
    id: "".concat(inputId, "_error"),
    "data-test": "".concat(dataTest || inputId, "_error"),
    customTheme: componentTheme
  }, componentTheme.showCancelIcon ?
  /*#__PURE__*/
  // check showCancelIcon in horizon theme
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CancelIcon, {
    "aria-label": "error",
    iconFill: "circlefill",
    size: "xsmall",
    svgColor: colors.red700
  }), /*#__PURE__*/React.createElement(ErrorText, null, errorText, " ", errorCta && errorCta)) : /*#__PURE__*/React.createElement(React.Fragment, null, errorText, errorCta && errorCta)), !errorText && helperText && /*#__PURE__*/React.createElement(HelperText, {
    id: "".concat(inputId, "_helptext"),
    "data-test": "".concat(dataTest || inputId, "_helptext"),
    adjustToBackgroundColor: adjustToBackgroundColor,
    customTheme: componentTheme,
    disabled: disabled
  }, helperText));
};
InputWrapper.displayName = 'InputWrapper';
export default InputWrapper;